<div class="w-full">
  <label 
    *ngIf="label()" 
    [class]="labelClasses()"
    [for]="inputId">
    {{ label() }}
    <span *ngIf="required()" class="text-red-500 ml-1">*</span>
  </label>
  
  <input
    [id]="inputId"
    [type]="type()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [class]="inputClasses()"
    [value]="valueSignal()"
    (input)="onInput($event)"
    (blur)="onBlur($event)"
    (focus)="onFocus($event)"
    [attr.aria-describedby]="error() ? inputId + '-error' : null"
    [attr.aria-invalid]="!!error()">
  
  <div 
    *ngIf="error()" 
    [id]="inputId + '-error'"
    class="mt-1 text-sm text-red-600">
    {{ error() }}
  </div>
</div>